import { render, staticRenderFns } from "./TareasWebApp.vue?vue&type=template&id=07836b9c&"
import script from "./TareasWebApp.vue?vue&type=script&lang=js&"
export * from "./TareasWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports